import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TypeResultatAttribution } from '../models/TypeResultatAttribution';
import { CTRL_268 } from '../../../validators/268/ctrl268';

@Component({
  selector: 'app-type-resultat-attribution',
  templateUrl: './type-resultat-attribution.component.html'
})
export class TypeResultatAttributionComponent implements OnInit {

  @Input() uid = '';
  @Input() parentForm: FormGroup;
  @Input() disabled: boolean;
  @Input() typeResultatAttribution: TypeResultatAttribution;
  @Input() resultat : TypeResultatAttribution;
  @Input() type: string;
  @Input() index = 0;
  public current_uid = 'TypeResultatAttribution';
  public rg1 = CTRL_268.id + '_3_';

  constructor() {
  }

  public ngOnInit() {
    this.parentForm.addControl(this.getStepId() + this.rg1 + this.index, new FormControl({ rgCtrls: this.getCtrl_268Names_json(this.index) }));
  }

  public getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  getStepId() {
    return this.uid.substring(0, this.uid.indexOf("SepSep"));
  }

  private getCtrl_268Names_json(lotMarcheIter): any {
    const deptPub = '_SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_deptPub';
    const cp = '_SepSep_Attribution_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_Attribution_index_' + lotMarcheIter + '_SepSep_LotMarche_SepSep_TypeResultatAttribution_SepSep_TypeAttributionMarcheLot_SepSep_TypeAdresseCompleteMorale_SepSep_TypeAdresse_SepAtt_cp';
    return { firstChamp: deptPub, secondChamp: cp };
  }

}
